import { useContext } from 'react';

import { ReactionsContext } from './ReactionsContext';

const useReactionsContext = () => {
  const context = useContext(ReactionsContext);
  if (!context) throw new Error('useReactionsContext must be used within a ReactionsContextProvider');

  return context;
};

export default useReactionsContext;
